var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrief(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.207 16C20.073 16 23.207 12.866 23.207 9C23.207 5.13401 20.073 2 16.207 2C12.341 2 9.20703 5.13401 9.20703 9C9.20703 12.866 12.341 16 16.207 16Z",
    fill: "#648CE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 31C10.866 31 14 27.866 14 24C14 20.134 10.866 17 7 17C3.13401 17 0 20.134 0 24C0 27.866 3.13401 31 7 31Z",
    fill: "#FA64A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31C28.866 31 32 27.866 32 24C32 20.134 28.866 17 25 17C21.134 17 18 20.134 18 24C18 27.866 21.134 31 25 31Z",
    fill: "#AA5AEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrief);
export default __webpack_public_path__ + "static/media/brief.6061b9e84892937581dcb92519db5a98.svg";
export { ForwardRef as ReactComponent };